import { useHistory } from "react-router-dom";

import ResponsiveSideNavigation from "@/components/navigation/ResponsiveSideNavigation";
import { theme } from "@/core/theme";
import {
  CMP_LEARNING_HUB_COURSES_URL,
  CMP_LEARNING_HUB_DASHBOARD_URL,
  CMP_LEARNING_HUB_EVENTS_URL,
  CMP_LEARNING_HUB_VIDEO_GUIDES_URL,
  CMP_LEARNING_HUB_WEBINARS_URL
} from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import CalendarIcon from "@/images/CalendarIcon";
import CirclePlayIcon from "@/images/CirclePlayIcon";
import FolderIcon from "@/images/FolderIcon";
import LearningHubDashboardIcon from "@/images/LearningHubDashboardIcon";
import OpenBookIcon from "@/images/OpenBookIcon";
import PageIcon from "@/images/PageIcon";
import PaperStackIcon from "@/images/PaperStackIcon";
import PenIcon from "@/images/PenIcon";
import PlayIcon from "@/images/PlayIcon";
import ThinSearchIcon from "@/images/ThinSearchIcon";

import { dashboardSidebarDesktopMinWidth } from "./dashboardLayout";

export default function NavigationInstance({
  desktopMinWidth = dashboardSidebarDesktopMinWidth,
  mobileNavMenuMaxWidthFrom = theme.breakpoints.sm,
  mobileDropdownProps: mobileDropdownPropsOverride,
  ...desktopProps
}) {
  const history = useHistory();
  const { resolvedUrls, isAtUrl } = useCmpRelatedUrl();

  return (
    <ResponsiveSideNavigation
      links={[
        {
          Icon: LearningHubDashboardIcon,
          label: "Dashboard",
          url: resolvedUrls[CMP_LEARNING_HUB_DASHBOARD_URL],
          active: isAtUrl(resolvedUrls[CMP_LEARNING_HUB_DASHBOARD_URL], { exact: true })[0]
        },
        {
          Icon: ThinSearchIcon,
          label: "Search",
          url: null,
          active: false
        },
        {
          Icon: PlayIcon,
          label: "Webinars",
          url: resolvedUrls[CMP_LEARNING_HUB_WEBINARS_URL],
          active: isAtUrl(resolvedUrls[CMP_LEARNING_HUB_WEBINARS_URL])[0]
        },
        {
          Icon: CalendarIcon,
          label: "Events",
          url: resolvedUrls[CMP_LEARNING_HUB_EVENTS_URL],
          active: isAtUrl(resolvedUrls[CMP_LEARNING_HUB_EVENTS_URL])[0]
        },
        {
          Icon: PaperStackIcon,
          label: "Courses",
          url: resolvedUrls[CMP_LEARNING_HUB_COURSES_URL],
          active: isAtUrl(resolvedUrls[CMP_LEARNING_HUB_COURSES_URL])[0]
        },
        {
          Icon: CirclePlayIcon,
          label: "Videos",
          url: resolvedUrls[CMP_LEARNING_HUB_VIDEO_GUIDES_URL],
          active: isAtUrl(resolvedUrls[CMP_LEARNING_HUB_VIDEO_GUIDES_URL])[0]
        },
        {
          Icon: PenIcon,
          label: "Articles",
          url: null,
          active: false
        },
        {
          Icon: FolderIcon,
          label: "Platform guides",
          url: null,
          active: false
        },
        {
          Icon: OpenBookIcon,
          label: "FAQ'S",
          url: null,
          active: false
        },
        {
          Icon: PageIcon,
          label: "Support documents",
          url: null,
          active: false
        }
      ].map(({ Icon, label, url, active }) => ({
        key: label,
        label,
        active,
        disabled: !url,
        onClick: () => {
          if (url) {
            history.push(url);
          }
        },
        renderIcon: ({ disabled }) => (
          <Icon
            fill={disabled ? theme.colors.carbon : theme.colors.dark}
            size={24}
            width={24}
            height={24}
          />
        )
      }))}
      mobileDropdownProps={{
        minWidth: 200,
        maxWidth: [null, 353],
        width: "100%",
        mx: "auto",
        ...mobileDropdownPropsOverride
      }}
      desktopMinWidth={desktopMinWidth}
      mobileNavMenuMaxWidthFrom={mobileNavMenuMaxWidthFrom}
      desktopProps={desktopProps}
    />
  );
}
